import { render, staticRenderFns } from "./assetInventoryManage.vue?vue&type=template&id=4c44f86b&scoped=true"
import script from "./assetInventoryManage.vue?vue&type=script&lang=js"
export * from "./assetInventoryManage.vue?vue&type=script&lang=js"
import style0 from "./assetInventoryManage.vue?vue&type=style&index=0&id=4c44f86b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c44f86b",
  null
  
)

export default component.exports